<template>
  <h-dialog
    :title="type === 0 ? $t('headerModules.upPassword') : $t('userModules.login.password')"
    width="520px"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @onCancel="onCancel"
    @onOk="ok"
  >
    <el-form ref="formRef" :model="formValues" :rules="rules" :label-width="$t('common.mode') === 'zh-cn' ? '100px' : '180px'">
      <el-form-item :label="$t('userModules.upPassword.oldPassword')" prop="password" v-if="type === 0">
        <el-input v-model="formValues.password" :placeholder="$t('common.pleaseInput')" show-password type="password" />
      </el-form-item>
      <el-form-item :label="$t('userModules.upPassword.NewPassword')" prop="new_password1">
        <el-input v-model="formValues.new_password1" :placeholder="$t('userModules.upPassword.passwordPlaceholder')" show-password type="password" />
      </el-form-item>
      <el-form-item :label="$t('userModules.upPassword.confirmPassword')" prop="new_password2">
        <el-input v-model="formValues.new_password2" :placeholder="$t('userModules.upPassword.passwordPlaceholder')" show-password type="password" />
      </el-form-item>
      <!-- <el-form-item label="手机号" prop="phone">
        <div style="display: flex; align-items: center; gap: 10px;">
          <el-input
            v-model="formValues.phone"
            :maxlength="11"
            placeholder="请输入手机号"
            :disabled="type === 0"
            style="width: 100%;"
          />
          <el-button class="code-box" @click="getCode" v-btn-count-down="60">{{ codeText }}</el-button>
        </div>
      </el-form-item>
      <el-form-item label="短信验证码" prop="code">
        <el-input v-model="formValues.code" placeholder="验证码" :maxlength="8" />
        <div style="color: #86909c">{{ type === 0 ? '修改' : '重置' }}密码后需要重新登录</div>
      </el-form-item> -->
    </el-form>
  </h-dialog>
</template>

<script setup>
import { encryptedPassword } from '@/utils/tools'
import { clearLsAll, getLsUserInfo, onGoLoginPage } from '@/core/storage/ls'
import { ref, unref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { sendCode, updateLoginPwd, forgetLoginPwd } from '@/api/personnel/user'
import { $t } from '@/i18n'

defineExpose({
  toggleVisible
})

const CODE_LABEL = '获取验证码'

const visible = ref(false),
  confirmLoading = ref(false),
  formRef = ref(),
  codeText = ref(CODE_LABEL),
  type = ref(0),
  timer = ref(),
  formValues = ref({
    password: '',
    new_password1: '',
    new_password2: '',
    phone: ''
  }),
  rules = {
    password: [{ required: true, message: $t('common.pleaseInput') }],
    new_password1: [
      { required: true, message: $t('common.pleaseInput') },
      { min: 8, message: $t('userModules.upPassword.min8') },
      { max: 16, message: $t('userModules.upPassword.max16') },
      { validator: pwdValidator }
    ],
    new_password2: [
      { required: true, message: $t('common.pleaseInput') },
      { validator: validator }
    ],
    // phone: [{ required: true, message: '请填入手机号' }],
    // code: [{ required: true, message: '请填入验证码' }]
  }

function pwdValidator(rule, value, callback) {
  const pwdReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/
  if (!value) {
    callback('')
  } else if (!pwdReg.test(value)) {
    callback($t('userModules.upPassword.errMessage'))
  } else {
    callback()
  }
}

async function getCode() {
  if (timer.value) return
  let data = {
    phone: formValues.value.phone,
    msg_type: 0
  }
  const { result } = await sendCode(data)
  if (result) {
    ElMessage.success('短信发送成功')
  } else {
    timer.value = ''
  }
}

function toggleVisible(_type = 0) {
  if (_type == 0) {
    formValues.value.phone = getLsUserInfo()?.phone
  }
  // 0 修改密码     1 忘记密码
  type.value = _type
  visible.value = true
}

function onCancel() {
  unref(formRef).resetFields()
  visible.value = false
}

function validator(rule, value, callback) {
  const new_password1 = unref(formValues).new_password1
  if (value !== new_password1) {
    callback($t('userModules.upPassword.errMessage3'))
  } else {
    callback()
  }
}

function ok() {
  unref(formRef).validate((valid) => {
    if (valid) {

      confirmLoading.value = true
      if (type.value === 0) updatePassword()
      if (type.value === 1) forgetPassword()

      setTimeout(() => {
        confirmLoading.value = false
      }, 300)
    }
  })
}

//忘记密码
async function forgetPassword() {
  const data = {
    password: encryptedPassword(formValues.value.new_password1),
    phone: formValues.value.phone,
    code: formValues.value.code
  }
  const { result } = await forgetLoginPwd(data)
  if (result) {
    onCancel()
  }
}

//修改密码
async function updatePassword() {
  const data = {
    password: encryptedPassword(formValues.value.new_password1),
    phone: formValues.value.phone,
    code: formValues.value.code,
    old_password: encryptedPassword(formValues.value.password)
  }
  const { result } = await updateLoginPwd(data)
  if (result) {
    if (type.value === 0) {
      onGoLoginPage()
      setTimeout(() => {
        ElMessage.success($t('common.editSuccess'))
      }, 1000);
    } else {
      ElMessage.success($t('userModules.upPassword.upPasswordOK'))
      onGoLoginPage()
    }
  }
}
</script>

<style scoped>
.code-box {
  color: #4C86FE;
  cursor: pointer;
}
</style>
